import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { isNil } from 'lodash-es';
import { ITimeCol } from '../table.type';
import { ColBase } from './col.base';

@Component({
  selector: 'bixi-table-col-time',
  host: { '[class.bixi-table-col-time]': 'true' },
  template: `
    <bixi-time [time]="value" [format]="col.format || 'YYYY/MM/DD HH:mm'"
               [relative]="col.relative" [radio]="col.radio || 1" [timeout]="col.timeout || 24* 60"
               [duration]="col.duration || 1">
    </bixi-time>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BixiTableColTimeComponent extends ColBase implements OnChanges {
  _col: ITimeCol;
  @Input() col: ITimeCol;

  ngOnChanges(changes: SimpleChanges) {
    const { col } = changes;
    if (col) {
      const option = col.currentValue;
      this._col = col.currentValue;
      this._col.relative = isNil(option.relative) ? true : option.relative;
    }
  }
}


